import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteIcon from '@mui/icons-material/Delete';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import styles from './style.module.css'
import { DragDropProvider } from '@dnd-kit/react';
import { useSortable } from '@dnd-kit/react/sortable';
import ApiConfig from '../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import { useMountEffect } from '../../utils/hooks';

const generateGUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const reorder = (list, startIndex, endIndex) => {
  // console.log("reordering list", list);
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  // console.log("removed item", removed);
  result.splice(endIndex, 0, removed);
  // console.log("new list after reorder", result);

  // Create new objects with updated SeqId instead of mutating
  const updatedResult = result.map((tl, index) => ({
    ...tl,
    SeqId: index
  }));

  // console.log("list after updating seq id", updatedResult);
  return updatedResult;
};

function SortableTasklistItem({ id, index, tasklist, tasklists, missionTasklists, onDelete, onSelect }) {
  const {
    ref,
    isDragging,
  } = useSortable({ id, index });

  const style = {
    opacity: isDragging ? 0.5 : 1,
    display: 'flex',
    flex: 1,
    marginBottom: '8px',
    padding: '8px',
    backgroundColor: 'var(--muted-bg, #f5f5f5)',
    borderRadius: '4px',
  };

  const displayTasklist = tasklists.find(tl => tl.Id === missionTasklists[index].RobotTasklistId.Id) || tasklist;

  return (
    <div ref={ref} style={style}>
      <div style={{ display: "flex", flex: 0.05, alignItems: 'center', justifyContent: "center", cursor: 'grab' }}>
        <DragIndicatorIcon />
      </div>
      <div style={{ display: "flex", flexDirection: "column", flex: 0.9, marginLeft: '8px' }}>
        <Select
          value={displayTasklist}
          onChange={(e) => onSelect(e, index)}
          fullWidth
          size="small"
        >
          {tasklists.map((tl, idx) => (
            <MenuItem key={idx} value={tl}>
              {tl.Name}
            </MenuItem>
          ))}
        </Select>
      </div>
      <Button
        style={{ display: "flex", flex: 0.05, alignItems: 'center', justifyContent: "center" }}
        onClick={() => onDelete(index)}
      >
        <DeleteIcon />
      </Button>
    </div>
  );
}

function AddMission(props) {
    const [missionTasklists, setMissionTasklists] = useState([])
    const [mission, setMission] = useState({
      Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      Name: "",
      RobotMapId: "",
      Tasklists: [],
      Deleted: false,
      CreatedBy: "system",
      UpdatedBy: "system",
    })

    const tasklists = props.tasklists
    var maps = props.maps

    // var tasklist = {
    //   Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   Name: "",
    //   Description: "",
    //   Tasks: [],
    //   Deleted: false,
    //   CreatedBy: "system",
    //   UpdatedBy: "system",
    // }

    var missiontasklist = {
        RobotTasklistId: {
          Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
          Name: "string",
          Description: "string",
          Tasks: [],
          Deleted: false,
          CreatedBy: "system",
          UpdatedBy: "system"
        },
        SeqId: 0
      }

    // const getFormInitials = () => { // Add api call to get initials
    //   Promise.all([
    //   ]).then(results => {
    //     console.log("got results")
    //   }).catch(error => {
    //     console.error(error);
    //   });
    // }

    useEffect(() => {
      // console.log(props.tasklist)
      // console.log(tasks)
      if (props.mission !== null && props.mission !== undefined){
        // console.log("tasklist is not null or undefined")
        setMission(props.mission)
        setMissionTasklists(props.mission.Tasklists)
      }
    }, [props.mission, props.openAddMission]);

    const addMissionTasklist = () => {
      if (tasklists.length > 0) {

        const newTasklist = {
          ...missiontasklist,
          Id: generateGUID(),
          RobotTasklistId: tasklists[0],
          SeqId: missionTasklists.length
        }
        setMissionTasklists((prevMissionTasklists) => ([
          ...prevMissionTasklists,
          newTasklist
        ]))
      }
    }

    const formSubmit = () => {

      console.log("Callback function when form is submitted!");
      mission.Tasklists = missionTasklists
      if(String(props.mode) === String("add")){
        props.addMission(mission)
      } else {
        props.updateMission(mission)
      }
      // // console.log(tasklist)
      // setTasklistTasks([])
      // setTasklist({
      //   Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      //   Name: "",
      //   Description: "",
      //   Tasks: [],
      //   Deleted: false,
      //   CreatedBy: "system",
      //   UpdatedBy: "system",
      // })
      handleClose()
    }

    const handleClose = () => {
      setMissionTasklists([])
      setMission({
        Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        Name: "",
        RobotMapId: "",
        Tasklists: [],
        Deleted: false,
        CreatedBy: "system",
        UpdatedBy: "system",
      })
      props.handleClose()
    }

    const handleChange = (event)=>{
      // console.log(event.target.name)
      setMission({
        ...mission,
        [event.target.name]:event.target.value,
      })
    }
    // const {handleChange, values,errors,handleSubmit,handleClose} = useForm(formSubmit);
    // const formClose = () => {
    //   props.handleClose()
    //   handleClose()
    // }

    function handleDragEnd(event) {
      if (event.canceled) return;
      const { source } = event.operation;
      const { initialIndex, index } = source;
      console.log(initialIndex, index)
      if (initialIndex !== undefined && index !== undefined && initialIndex !== index) {
        const newList = reorder(missionTasklists, initialIndex, index);
        console.log(newList)
        setMissionTasklists(newList);
      }
    }

    const handleTasklistSelectChange = (event, index) => {
      const newMissionTasklists = [...missionTasklists]
      newMissionTasklists[index].RobotTasklistId = event.target.value
      newMissionTasklists.forEach((tl,taskIndex)=>{
        tl.SeqId = taskIndex
      })
      setMissionTasklists(newMissionTasklists)
    };

    const handleDeleteMissionTasklist = (index) => {
      // console.log(tasklisttask, index)
      const newMissionTasklists = [...missionTasklists]
      newMissionTasklists.splice(index, 1)
      // console.log(newTasklistTasks)
      newMissionTasklists.forEach((tl,index)=>{
        tl.SeqId = index
      })
      setMissionTasklists(newMissionTasklists)
    }

    const renderTasklist = (tasklist, index) => {
      tasklists.forEach((tl)=>{
        if(String(tl.Id) === String(missionTasklists[index].RobotTasklistId.Id)){
          tasklist=tl
        }
      })
      // Use tasklist's RobotTasklistId as stable ID instead of array index
      const stableId = missionTasklists[index].Id;
      return (
        <SortableTasklistItem
          key={stableId}
          id={stableId}
          index={index}
          tasklist={tasklist}
          tasklists={tasklists}
          missionTasklists={missionTasklists}
          onDelete={handleDeleteMissionTasklist}
          onSelect={handleTasklistSelectChange}
        />
      );
    }

    return(
      <Modal
        open={props.openAddMission}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box component="form" sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '50%',
            height: '50%',
            bgcolor: 'background.paper',
            border: '2px solid',
            borderColor: 'divider',
            borderRadius: 10,
            boxShadow: 24,
            p: 4,
            overflowY: "auto"
          }}>
          <Typography variant="h6" gutterBottom>
              {String(props.mode) === String("add") ? "Create New Tasklist" : "Edit Tasklist"}
          </Typography>
          <TextField
              required
              fullWidth
              label="Mission Name"
              value={mission.Name}
              name="Name"
              onChange={handleChange}
              margin="normal"
          />
          <InputLabel id="demo-simple-select-label">Map</InputLabel>
            <Select
                style={{width: "100%"}}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Map"
                value={mission.RobotMapId}
                name="RobotMapId"
                onChange={handleChange}
            >
                {maps.map((map, index)=>{
                    return(
                        <MenuItem key={index} value={map.Id}>
                            {map.MapName}
                        </MenuItem>
                    )
                })}
            </Select>
          <Typography gutterBottom>
              Tasklists
          </Typography>

          <DragDropProvider onDragEnd={handleDragEnd}>
            <div>
              {missionTasklists.map((tasklist, index) => {
                return renderTasklist(tasklist, index);
              })}
            </div>
          </DragDropProvider>
        <Button variant="outlined" sx={{ width: "100%", mt: 1 }} onClick={addMissionTasklist}>+</Button>
          <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={formSubmit}>
              Submit
          </Button>
          {String(props.mode) === String("add") ? null:<Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={()=>{props.deleteMission(mission); handleClose()}}>
              Delete
          </Button>}
          </Box>
      </Modal>
    )
  }

function Missions(props){

    const { keycloak } = useKeycloak();
    const a = new ApiConfig(keycloak)
    const apiConfig = a.api()

    const [mode, setMode] = useState("add")
    const [openAddMission, setOpenAddMission] = useState(false);
    const handleAddMissionClose = () => {setEditingMission(null);setOpenAddMission(false)};
    const handleAddMissionOpen = (mode) => {retrieveMissions(); setMode(mode); setOpenAddMission(true);};

    const [tasklists, setTasklists] = useState([])
    const [missions, setMissions] = useState([])
    const [maps, setMaps] = useState([])
    const [editingMission, setEditingMission] = useState(null)

    const retrieveMissions = () => {
        Promise.all([
          apiConfig.fetchTasklistInfo(),
          apiConfig.fetchMissionInfo(),
          apiConfig.fetchAllMaps(props.robotId ? props.robotId : "e856f3b3-c04c-4ff3-af63-2c5e42f0f542"),
        ]).then(results => {
            // console.log(results[0].RobotResponse)
            // console.log(results[1].RobotResponse)
            // console.log(results[2].RobotResponse)
            setTasklists(results[0].RobotResponse)
            setMissions(results[1].RobotResponse)
            setMaps(results[2].RobotResponse)
        }).catch(error => {
            console.error(error);
        });
      }

    useMountEffect(() => {
        retrieveMissions()
        return () => {
            // This code runs when the component is unmounted
            // Perform cleanup or unsubscribe from resources
            // console.log("Disconnecting from websocket...")
            // socket.close()
        };

    }, []);

    const renderMission = (mission, index) => {
        return(
          <Button key={index} variant="outlined" sx={{ width: "100%", justifyContent: 'flex-start', mb: 0.5 }} onClick={()=>{handleAddMissionOpen("edit");setEditingMission(mission)}}>
            {mission.Name}
          </Button>
        )
    }

    return(
        <Grid container display="flex" alignItems="center" justifyContent="center" direction="column" item xs={12} sm={12} md={4} lg={4} xl={4}>
            <p className={styles.font} style={{ fontSize: 20}}>Missions</p>
            <Button variant="outlined" sx={{ width: "100%" }} onClick={()=>{handleAddMissionOpen("add")}}>+</Button>
            {
                missions.map((mission, index)=>{
                    return((renderMission(mission, index)))
                })
            }
        <AddMission mode={mode} maps={maps} mission={editingMission} handleClose={handleAddMissionClose} tasklists={tasklists} deleteMission={(mission)=>{apiConfig.deleteMission(mission.Id).then(response=>{console.log(response); retrieveMissions()})}} openAddMission={openAddMission} updateMission={(mission)=>{console.log(`Update mission `, mission); apiConfig.updateMission(mission.Id, mission).then((response)=>{console.log(response); retrieveMissions()})}} addMission={(mission)=>{console.log(`Add mission `, mission); apiConfig.createMission(mission).then((response)=>{console.log(response); retrieveMissions()});}}/>
        </Grid>
    )
}

export {Missions}